import ValoresRepository from '@/services/ValoresRepository'
import ConfiguracionRepository from '@/services/ConfiguracionRepository'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    listaPersonalAgricultor: [],
    listaPersonal: [],
  },
  getters: {
    getPersonal: (state) => (idPersonal) => {
      return state.listaPersonalAgricultor.find(personal => personal.idPersonal === idPersonal)
    },
  },
  mutations: {
    setListaPersonalAgricultor(state, listaPersonalAgricultor) {
      state.listaPersonalAgricultor = listaPersonalAgricultor.map(personalAgricultor => {
        personalAgricultor.costoHoraFormated = Vue.filter('fhNumber')(personalAgricultor.costoHora) + ' / Hs'
        return personalAgricultor
      })
    },

    setListaPersonal(state, listaPersonal) {
      state.listaPersonal = listaPersonal
    },

    clearPersonal(state) {
      state.listaPersonalAgricultor = []
      state.listaPersonal = []
    },
  },
  actions: {
    async fetchListaPersonalAgricultor({state, commit, rootState}) {
      if (state.listaPersonalAgricultor && state.listaPersonalAgricultor.length > 0) {
        return
      }

      let idEstablecimiento = rootState.establecimientos.establecimiento.idEstablecimiento
      let idGrupoExplotacion = rootState.establecimientos.currentGrupoExplotacion.idGrupoExplotacion

      let listaPersonalAgricultor = await ConfiguracionRepository.listaPersonalAgricultor(idEstablecimiento, idGrupoExplotacion)
      commit('setListaPersonalAgricultor', listaPersonalAgricultor)
    },

    async fetchListaPersonal({state, commit, rootState}) {
      if (state.listaPersonal && state.listaPersonal.length > 0) {
        return
      }
      let idEstablecimiento = rootState.establecimientos.establecimiento.idEstablecimiento
      let idGrupoExplotacion = rootState.establecimientos.currentGrupoExplotacion.idGrupoExplotacion

      let listaPersonal = await ValoresRepository.listaPersonal(idEstablecimiento,idGrupoExplotacion)
      commit('setListaPersonal', listaPersonal)
    },

    clearPersonal({commit}) {
      commit('clearPersonal')
    },
  }
}
